var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loaded)?_c('LineChart',{staticClass:"graph",attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }